<template>
  <v-card>
    <v-card-title class="primary white--text font-weight-bold"
      >Nuevo Evento <v-spacer></v-spacer
      ><v-icon dark @click="$emit('close')">mdi-close</v-icon></v-card-title
    >
    <v-container>
      <v-form ref="form" @submit.prevent="addEvent">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field type="text" label="Nombre" v-model="name">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field type="text" label="Detalles" v-model="details">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select :items="types" label="Recurrent or unique" v-model="type">
            </v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select :items="subtypes" label="Type" v-model="subtype">
            </v-select>
          </v-col>
          <template v-if="type === 'recurrent'">
            <v-col cols="6">
              <v-text-field
                clearable
                clear-icon="mdi-cancel"
                :rules="timeRules"
                v-model="valueChangeTime"
                label="Repeat each"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="selectedChangeTime"
                :items="timeObj"
                item-text="name"
                return-object
              >
              </v-select>
            </v-col>
          </template>
          <v-col cols="12" md="6">
            <v-text-field type="date" label="Fecha de Inicio" v-model="start">
            </v-text-field
          ></v-col>
          <v-col cols="12" md="6"
            ><v-text-field type="date" label="Fecha Final" v-model="end">
            </v-text-field
          ></v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            type="submit"
            color="primary"
            class="mr-4"
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click.stop="dialog = false"
            >Agregar</v-btn
          ><v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
      <v-dialog persistent max-width="350px" v-model="modalAfter">
        <v-card>
          <v-container>
            <v-row justify="center">
              <v-col cols="12">
                <v-btn
                  color="primary"
                  block
                  class="my-2 mx-0"
                  @click="handleGoToProfile"
                >
                  Go to task's profile
                </v-btn>
                <v-btn
                  color="primary"
                  block
                  class="my-2 mx-0"
                  @click="handleCreateAnotherTask"
                >
                  Create another task
                </v-btn>
                <v-btn
                  color="primary"
                  block
                  class="my-2 mx-0"
                  @click="handleGoBackTo"
                >
                  Go back to Calendar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "NewCalendarEvent",
  data() {
    return {
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      name: null,
      details: null,
      color: "#1976D2",
      type: "unique",
      subtype: "maintenance",
      types: ["recurrent", "unique"],
      subtypes: ["maintenance", "repair", "reliability"],
      timeObj: [
        { name: "year", value: 31536000 },
        { name: "month", value: 2592000 },
        { name: "week", value: 604800 },
        { name: "day", value: 86400 }
      ],
      selectedChangeTime: { name: "day", value: 86400 },
      valueChangeTime: 0,
      timeRules: [v => v > 0 || "This field have to be greater than 0."],
      modalAfter: false
    };
  },
  computed: {
    changeTimeRealValue() {
      return this.valueChangeTime * this.selectedChangeTime.value;
    }
  },
  methods: {
    async addEvent() {
      try {
        if (this.name && this.start && this.end) {
          const payload = {
            db: "calendar",
            data: {
              name: this.name,
              details: this.details,
              start: this.start,
              end: this.end,
              color: this.color,
              type: this.type,
              subtype: this.subtype,
              changeTime: this.changeTimeRealValue,
              disabledArray: []
            }
          };
          await this.$store.dispatch("addDocument", payload);

          this.name = null;
          this.details = null;
          this.start = null;
          this.end = null;
          this.color = "#1976D2";
          this.type = "unique";
          this.subtype = "maintenance";
          this.selectedChangeTime = { name: "day", value: 86400 };
          this.valueChangeTime = 0;

          this.modalAfter = true;
        } else {
          this.$dialog.notify.error("Campos Obligatorios", {
            position: "top-right",
            timeout: 5000
          });
        }
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
    },
    handleGoToProfile() {
      // ! Task profile is not working
      this.$router.push({
        path: `/task-profile/${this.selectedEvent.id}`
      });
    },
    handleCreateAnotherTask() {
      this.$refs.form.reset();
    },
    handleGoBackTo() {
      this.$emit("close");
    }
  }
};
</script>
